import {
  toggleMobileMenu,
  updateOnScroll,
  lineupButtonsGrid,
  fixSearchFocus,
} from '../js/helpers/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  contentMarginTop();
  toggleMobileMenu();
  modifySignup();
  createMapButton();
  fixSearchFocus();
});

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    lineupButtonsGrid($(element));
  });
}
// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header')[0].getBoundingClientRect().height;
    const isHomepage = $('body').hasClass('homepage');
    const generalMessageHeight = $('.generalmessage').length
      ? $('.generalmessage').outerHeight()
      : 0;
    const isMobile = $(globalThis).innerWidth <= 1100;

    let marginTop = headerHeight;

    updateOnScroll(generalMessageHeight);

    if (!isHomepage && !isMobile) {
      marginTop += 12;
    }

    $('.content').css('margin-top', marginTop + 'px');
  }

  $(document).ready(updateContentMargin);
  $(globalThis).on('load resize', updateContentMargin);
  new ResizeObserver(updateContentMargin).observe(document.querySelector('.header'));
}

// Customize Sign Up Widget
function modifySignup() {
  const signupWidget = $('.tier-four .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h6>Join our merry band!</h6>
        <p>Sign up for our newsletter and recieve the secrets<br>of the kingdom right to your inbox.</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('Don’t miss out!');
  });
}

// Adds "Directions" button to the map
function createMapButton() {
  const cardhref = $('.standAloneDirections');
  cardhref.addClass('button');
  cardhref.text('Directions');

  $('.map-container .ribbon').append(cardhref);
}
